'use client';
import React, { useEffect, useRef } from 'react';

const testimonials = [
  {
    quote: 'Antes usábamos Excel y WhatsApp para todo. En la primera semana con DriveX cerramos dos ventas que habrían sido leads perdidos. El pipeline cambió todo.',
    initials: 'CM',
    name: 'Carlos M.',
    role: 'Gerente General',
    company: 'Automotores Norte, Bucaramanga',
  },
  {
    quote: 'El dashboard de finanzas me mostró que mi mejor margen no era en los SUV sino en los Can-Am. Eso cambió cómo armo mi inventario.',
    initials: 'LV',
    name: 'Laura V.',
    role: 'Directora Comercial',
    company: 'SUV Premium, Medellín',
  },
  {
    quote: 'Las fichas técnicas en PDF son increíbles. Mis clientes las reciben por WhatsApp en 30 segundos. Parece que tenemos un equipo de marketing detrás.',
    initials: 'AB',
    name: 'Andrés B.',
    role: 'Propietario',
    company: 'Moto Acuática Caribe, Barranquilla',
  },
];

export default function DriveXTestimonials() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.dx-reveal').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 150);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="dx-font"
      style={{ background: '#111111', padding: '100px 0' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14 dx-reveal">
          <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: '#C8102E', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '16px' }}>
            LO QUE DICEN LOS CONCESIONARIOS
          </div>
          <h2 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: 'clamp(32px, 4vw, 52px)', color: '#FFFFFF' }}>
            Resultados reales.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials?.map((t, i) => (
            <div
              key={i}
              className="dx-reveal"
              style={{ background: '#1A1A1A', border: '0.5px solid rgba(255,255,255,0.06)', borderRadius: '12px', padding: '28px' }}
            >
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: '64px', color: '#C8102E', opacity: 0.3, lineHeight: 1, marginBottom: '8px' }}>"</div>
              <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '14px', color: '#AAAAAA', lineHeight: 1.8, fontStyle: 'italic', marginBottom: '20px' }}>
                {t?.quote}
              </p>
              <div style={{ borderTop: '1px solid #2A2A2A', paddingTop: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#3A3A3A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '13px', color: '#AAAAAA', flexShrink: 0 }}>
                  {t?.initials}
                </div>
                <div>
                  <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '13px', color: '#FFFFFF' }}>{t?.name}</div>
                  <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '11px', color: '#888888' }}>{t?.role} · {t?.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
